import { ConnectionSection } from './ConnectionSection';
import { FormattedMessage } from 'react-intl';
import { Box, Button, Typography } from '@mui/material';
import { ConnectedConnectionItem } from './ConnectedConnectionItem';
import { ConnectedConnections } from '../hook/useUserConnection';
import { useConnectionDispatch } from './ConnectionDispatchProvider';
import { useFetchMoreConnectedConnections } from '../hook/useFetchUserConnection';
import { LoadingIndicator } from '@xolv-mybrightlink/common';

type ConnectedSectionProps = {
  connectedConnections: ConnectedConnections;
};

export const ConnectedSection = ({
  connectedConnections,
}: ConnectedSectionProps) => {
  const { connections, hasMore } = connectedConnections;
  const connectionDispatch = useConnectionDispatch();
  const loadMore = useFetchMoreConnectedConnections(
    connectedConnections,
    connectionDispatch,
  );
  const title = (
    <Typography variant='subtitle1'>
      <FormattedMessage
        id='community.connections.connection-connected.title'
        values={{ numOfConnection: connections.length }}
      />
    </Typography>
  );
  const detail =
    connections.length == 0 ? (
      <Box>
        <Typography>
          <FormattedMessage id='community.connections.connection-connected.empty' />
        </Typography>
      </Box>
    ) : (
      <Box>
        {connections.map((connection) => (
          <ConnectedConnectionItem
            key={connection.guid}
            connection={connection}
          />
        ))}
        {hasMore && connectedConnections.loading && <LoadingIndicator />}
        {hasMore && !connectedConnections.loading && (
          <Button onClick={loadMore} variant='text' sx={{ px: 0 }}>
            Load more
          </Button>
        )}
      </Box>
    );
  return <ConnectionSection title={title} detail={detail} />;
};
